import React, { useContext, useState } from 'react'
import Button, { ButtonTheme } from 'components/Form/Button'
import Modal from 'components/Modal'
import { useTranslation } from 'react-i18next'
import Input from 'components/Form/Input'
import VoohCampaignFormService from '../service'
import { AppContext } from '../../../../contexts/AppContext'
import { store } from '../../../../store'
import { voohCampaignFormActions } from '../slice'
import { CardStatus } from '../../../../components/Layout/Card'
import { NotifierType } from '../../../../components/Notifier'

type Props = {
  media: number[]
  close: () => void
  goBack: () => void
}

const VoohCreateMediaTemplateModal: React.FC<Props> = ({ media, goBack, close }) => {
  const [templateName, setTemplateName] = useState<string>('')
  const { t } = useTranslation()
  const { addNotification } = useContext(AppContext)

  const save = () => {
    store.dispatch(voohCampaignFormActions.setCardStatus({ details: CardStatus.SAVING }))

    VoohCampaignFormService.createVoohMediaTemplate(templateName, media)
      .then(res => {
        if (res.data) {
          store.dispatch(voohCampaignFormActions.setCardStatus({ details: CardStatus.SAVED }))
          addNotification(NotifierType.SUCCESS, t('mediaSelection.template.create.success'))
        }
      })
      .catch(
        () =>
          void store.dispatch(voohCampaignFormActions.setCardStatus({ details: CardStatus.ERROR }))
      )
    close()
  }

  const Footer = (
    <div className='MediaSelectionModal__template-footer'>
      <Button
        disabled={!templateName}
        onClick={save}
      >
        {t('common.save')}
      </Button>

      <Button
        theme={ButtonTheme.BLUE_OUTLINE}
        onClick={goBack}
      >
        {t('common.back')}
      </Button>
    </div>
  )

  return (
    <Modal
      isOpen={true}
      onClose={close}
      footer={Footer}
    >
      <div className='TemplateSection'>
        <Input
          id={'templateName'}
          title={t('mediaSelection.template.name')}
          value={templateName}
          onChange={setTemplateName}
        />
      </div>
    </Modal>
  )
}

export default VoohCreateMediaTemplateModal
